import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { airtimeAndDataSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const AirtimeAndData = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.AIRTIME_AND_DATA} items={airtimeAndDataSubpages} />
);

export default AirtimeAndData;
